import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ListUserFilter,
  ListUserResponse,
  UserData,
  PermissionData,
} from 'src/app/class/datatype';
import { environment } from 'src/environments/environment';
import { each } from 'lodash-es';

@Injectable()
export class UserService {
  constructor(private http: HttpClient) {}

  listUser(filter: ListUserFilter): Observable<ListUserResponse> {
    let params = new HttpParams();

    if (filter.username) {
      params = params.append('username', filter.username.toString());
    }

    if (filter.name) {
      params = params.append('name', filter.name.toString());
    }

    if (filter.access) {
      params = params.append('access', filter.access.toString());
    }

    if (filter.page) {
      params = params.append('page', filter.page.toString());
    }

    return this.http.get<ListUserResponse>(
      environment.apiUrl + 'clientapi/admin/user',
      { params }
    );
  }

  preparePermissionArray(permission: PermissionData): string[] {
    const permissionList = [];

    each(permission, (contex, index) => {
      each(contex, (p, cindex) => {
        if (p) {
          permissionList.push(index + '.' + cindex);
        }
      });
    });

    return permissionList;
  }

  saveUser(user: UserData, permission: PermissionData): Observable<any> {

    const data = {
      id: user.id,
      branch_access: user.branch,
      data_status_access: user.dataStatus,
      data_access_download: user.dataAccessDownload,
      username: user.username,
      name: user.name,
      access: user.access,
      scope: user.scope,
      password: user.password,
      confirm_password: user.confirm_password,
      permission: this.preparePermissionArray(permission),
    };

    if (user.id) {
      return this.http.put(environment.apiUrl + 'clientapi/admin/user', data);
    } else {
      return this.http.post(environment.apiUrl + 'clientapi/admin/user', data);
    }
  }
}
